import "./tag-color.scss";

import { CouponStatus } from "@core/model/coupon-status.enum";
import { ReferralStatus } from "@core/model/referral-status.enum";
import { RegistrationStatus } from "@core/model/registration-status.enum";
import { TransactionAction } from "@core/model/transaction-action.enum";
import classNames from "classnames";
import { Tag } from "primereact/tag";

export interface TagColorProps {
  value: string;
}

export function TagColor({ value }: TagColorProps) {
  const mapColor = {
    ["0"]: "bg-blue-200",
    ["1"]: "bg-green-200",
    ["OR"]: "bg-blue-200",
    ["AND"]: "bg-green-200",
    [TransactionAction.Earn]: "bg-green-200",
    [TransactionAction.Redeem]: "bg-violet-200",
    [RegistrationStatus.PENDING]: "bg-blue-200",
    [RegistrationStatus.REJECTED]: "bg-red-200",
    [RegistrationStatus.PROCESSED]: "bg-green-200",
    [CouponStatus.AVAILABLE]: "bg-orange-200",
    [CouponStatus.NOT_AVAILABLE]: "bg-red-200",
    [CouponStatus.CLAIMED]: "bg-green-200",
    [ReferralStatus.PENDING]: "bg-blue-200",
    [ReferralStatus.APPROVED]: "bg-green-200",
  };
  const mapLabel = {
    ["0"]: "No",
    ["1"]: "Yes",
    ["OR"]: "OR",
    ["AND"]: "AND",
    [TransactionAction.Earn]: TransactionAction.Earn,
    [TransactionAction.Redeem]: TransactionAction.Redeem,
    [RegistrationStatus.PENDING]: "Pending",
    [RegistrationStatus.REJECTED]: "Rejected",
    [RegistrationStatus.PROCESSED]: "Processed",
    [CouponStatus.AVAILABLE]: "Available",
    [CouponStatus.NOT_AVAILABLE]: "Not Available",
    [CouponStatus.CLAIMED]: "Claimed",
    [ReferralStatus.PENDING]: "Pending",
    [ReferralStatus.APPROVED]: "Approved",
  };
  const mapTextColor = {
    ["0"]: "text-blue-700",
    ["1"]: "text-green-700",
    ["OR"]: "text-blue-700",
    ["AND"]: "text-green-700",
    [TransactionAction.Earn]: "text-green-700",
    [TransactionAction.Redeem]: "text-violet-700",
    [RegistrationStatus.PENDING]: "text-blue-700",
    [RegistrationStatus.REJECTED]: "text-red-700",
    [RegistrationStatus.PROCESSED]: "text-green-700",
    [CouponStatus.AVAILABLE]: "text-orange-700",
    [CouponStatus.NOT_AVAILABLE]: "text-red-700",
    [CouponStatus.CLAIMED]: "text-green-700",
    [ReferralStatus.PENDING]: "text-blue-700",
    [ReferralStatus.APPROVED]: "text-green-700",
  };

  return (
    <div id="TagColor" className="tag-color">
      <Tag className={classNames(mapColor[value as keyof typeof mapColor], mapTextColor[value as keyof typeof mapColor])}>
        <div className="flex align-items-center gap-2">
          {mapLabel[value as keyof typeof mapLabel]}
        </div>
      </Tag>
    </div>
  );
}

export default TagColor;
